import type {
  ClassroomTestRoundDetailQuery,
  TestsAndResultsQuery,
} from '@innovamat/glow-api-client';

export const getRelativeMonthDate = (months: number): string => {
  const date = new Date();
  date.setMonth(date.getMonth() + months);

  const year = date.getFullYear();
  const month = date.getMonth();
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
  const randomDay = Math.floor(Math.random() * lastDayOfMonth) + 1;

  date.setDate(randomDay);
  const formattedYear = date.getFullYear();
  const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
  const formattedDay = String(date.getDate()).padStart(2, '0');

  return `${formattedYear}-${formattedMonth}-${formattedDay} 00:00:00`;
};

export const testsAndResultsMockData: TestsAndResultsQuery = {
  testsAndResults: [
    {
      testId: 'fd2729f9-72f1-4e4e-845e-cdcf3f9b3214',
      classroomTestRoundId: '019522d4-fake-data-8da5-29a9668731d3',
      roundName: 'FAKE.MOCK_EXAM_01.title',
      status: 'completed',
      password: '9470',
      startDate: getRelativeMonthDate(-3),
      endDate: getRelativeMonthDate(-1),
      test: {
        type: 'MOCK',
      },
      report: {
        deliveryDate: null,
      },
      participation: {
        total: 26,
        completed: 20,
      },
    },
    {
      testId: '89469b8f-1330-4d07-8b38-41c5cd7b87f6',
      classroomTestRoundId: '019522d4-fake-data-9431-0717a4e8251f',
      roundName: 'FAKE.MOCK_EXAM_02.title',
      status: 'completed',
      password: '2460',
      startDate: getRelativeMonthDate(-4),
      endDate: getRelativeMonthDate(-2),
      test: {
        type: 'MOCK',
      },
      report: {
        deliveryDate: null,
      },
      participation: {
        total: 26,
        completed: 21,
      },
    },
    {
      testId: 'bb8d8e99-7ff1-4d4d-acd3-a6fabf112216',
      classroomTestRoundId: '51ae12e6-fake-data-a34c-2defd440bd04',
      roundName: 'FAKE.CONMAT_01.title',
      status: 'started',
      password: '1205',
      startDate: getRelativeMonthDate(-1),
      endDate: getRelativeMonthDate(1),
      test: {
        type: 'CONMAT',
      },
      report: {
        deliveryDate: null,
      },
      participation: {
        total: 26,
        completed: 0,
      },
    },
    {
      testId: 'b7e1971d-ae35-4114-b6b9-deb1c465fe73',
      classroomTestRoundId: '924b8f96-fake-data-a2d7-9da39d677cc9',
      roundName: 'FAKE.CONMAT_02.title',
      status: 'completed',
      password: '4855',
      startDate: getRelativeMonthDate(-6),
      endDate: getRelativeMonthDate(-5),
      test: {
        type: 'CONMAT',
      },
      report: {
        deliveryDate: '2025-01-30 00:00:00',
      },
      participation: {
        total: 26,
        completed: 18,
      },
    },
    {
      testId: 'e13d532f-efe2-4ab3-9c21-1a08b50c9f11',
      classroomTestRoundId: 'dcd83954-fake-data-9121-42cf0ce9fb07',
      roundName: 'FAKE.COSMOS_01.title',
      status: 'completed',
      password: '7261',
      startDate: getRelativeMonthDate(-6),
      endDate: getRelativeMonthDate(-5),
      test: {
        type: 'COSMOS',
      },
      report: {
        deliveryDate: '2025-01-07 00:00:00',
      },
      participation: {
        total: 9,
        completed: 10,
      },
    },
  ],
};

export const getFaketestsAndResultsMockDataDetailsData = (
  classroomTestRoundId: string
): ClassroomTestRoundDetailQuery => {
  const test = testsAndResultsMockData.testsAndResults.find(
    (test) => test.classroomTestRoundId === classroomTestRoundId
  );
  return {
    classroomTestRoundDetail: {
      id: '0194a743-fake-data-73ba-8c16-b623cd043bb3',
      title: test?.roundName,
      description: 'FAKE.MOCK_EXAM_01.desc',
      duration: 0,
      status: 'completed',
      startDate: test?.startDate,
      endDate: test?.endDate,
      participation: test?.participation,
      numberOfStatements: 28,
      statements: {
        multipleChoicePositionLabels: ['A', 'B', 'C', 'D'],
        evaluations: [
          {
            type: 'multiple-choice',
            position: 0,
            notAnswered: 0,
            correctlyAnswered: 65,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 30,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 65,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 1,
            notAnswered: 0,
            correctlyAnswered: 90,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 90,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 5,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 2,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 75,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 3,
            notAnswered: 0,
            correctlyAnswered: 85,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 85,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 4,
            notAnswered: 0,
            correctlyAnswered: 65,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 65,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 5,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 5,
            notAnswered: 0,
            correctlyAnswered: 85,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 85,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 6,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 75,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 7,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 75,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 8,
            notAnswered: 0,
            correctlyAnswered: 95,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 95,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 9,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 75,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 10,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 10,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 75,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 11,
            notAnswered: 0,
            correctlyAnswered: 100,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 100,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 12,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 25,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 75,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 13,
            notAnswered: 0,
            correctlyAnswered: 90,
            answers: [
              {
                positionLabel: 'A',
                answered: 90,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 14,
            notAnswered: 0,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 75,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 15,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 15,
            notAnswered: 0,
            correctlyAnswered: 70,
            answers: [
              {
                positionLabel: 'A',
                answered: 70,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 25,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 5,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 16,
            notAnswered: 0,
            correctlyAnswered: 80,
            answers: [
              {
                positionLabel: 'A',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 80,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 5,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 17,
            notAnswered: 0,
            correctlyAnswered: 85,
            answers: [
              {
                positionLabel: 'A',
                answered: 85,
                isCorrect: true,
              },
              {
                positionLabel: 'B',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 18,
            notAnswered: 0,
            correctlyAnswered: 65,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 65,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 5,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 19,
            notAnswered: 5,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 75,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 20,
            notAnswered: 5,
            correctlyAnswered: 70,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 70,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 15,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 21,
            notAnswered: 5,
            correctlyAnswered: 25,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 25,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 55,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 22,
            notAnswered: 5,
            correctlyAnswered: 65,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 65,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 15,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 23,
            notAnswered: 5,
            correctlyAnswered: 65,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 65,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 10,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 24,
            notAnswered: 5,
            correctlyAnswered: 80,
            answers: [
              {
                positionLabel: 'A',
                answered: 10,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 80,
                isCorrect: true,
              },
              {
                positionLabel: 'C',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 25,
            notAnswered: 5,
            correctlyAnswered: 85,
            answers: [
              {
                positionLabel: 'A',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 5,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 85,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 26,
            notAnswered: 5,
            correctlyAnswered: 60,
            answers: [
              {
                positionLabel: 'A',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 15,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'D',
                answered: 60,
                isCorrect: true,
              },
            ],
          },
          {
            type: 'multiple-choice',
            position: 27,
            notAnswered: 5,
            correctlyAnswered: 75,
            answers: [
              {
                positionLabel: 'A',
                answered: 20,
                isCorrect: false,
              },
              {
                positionLabel: 'B',
                answered: 0,
                isCorrect: false,
              },
              {
                positionLabel: 'C',
                answered: 75,
                isCorrect: true,
              },
              {
                positionLabel: 'D',
                answered: 0,
                isCorrect: false,
              },
            ],
          },
        ],
      },
      statementsMeta: [
        {
          position: 0,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 1,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 2,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 3,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 4,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 5,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 6,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 7,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 8,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 9,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 10,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 11,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 12,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 13,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 14,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 15,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 16,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 17,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 18,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 19,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 20,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 21,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 22,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 23,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 24,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 25,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 26,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
        {
          position: 27,
          answersMetrics: {
            largestAnswerWidth: 2,
          },
        },
      ],
      students: [
        {
          id: '1ebe5438-0418-6306-af88-02ae5b23cf47',
          firstName: 'Jack',
          lastName: 'Thompson',
          score: 78.57,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'B',
              gradePercentage: 0,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'B',
              gradePercentage: 0,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'A',
              gradePercentage: 0,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'D',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'C',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-63c4-af88-02ae5b23cf47',
          firstName: 'Emma',
          lastName: 'García',
          score: 64.29,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-647f-af88-02ae5b23cf47',
          firstName: 'Sofia',
          lastName: 'Morales',
          score: 82.14,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'C',
              gradePercentage: 0,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'B',
              gradePercentage: 0,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'B',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-653c-af88-02ae5b23cf47',
          firstName: 'Laura',
          lastName: 'Williams',
          score: 60.71,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'D',
              gradePercentage: 0,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'C',
              gradePercentage: 0,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'C',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'B',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'C',
              gradePercentage: 0,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'A',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'A',
              gradePercentage: 0,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'D',
              gradePercentage: 0,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'B',
              gradePercentage: 1,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'C',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'A',
              gradePercentage: 0,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'C',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-65fc-af88-02ae5b23cf47',
          firstName: 'Robert',
          lastName: 'Martínez',
          score: 85.71,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'B',
              gradePercentage: 0,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'B',
              gradePercentage: 0,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'A',
              gradePercentage: 0,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'B',
              gradePercentage: 1,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'A',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-66ba-af88-02ae5b23cf47',
          firstName: 'Ahmed',
          lastName: 'Hassan',
          score: 82.14,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'C',
              gradePercentage: 0,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'B',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'C',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'C',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'A',
              gradePercentage: 0,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-68f4-af88-02ae5b23cf47',
          firstName: 'Noah',
          lastName: 'Smith',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-6a7a-af88-02ae5b23cf47',
          firstName: 'Julia',
          lastName: 'Fischer',
          score: 75,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'B',
              gradePercentage: 0,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'A',
              gradePercentage: 0,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'C',
              gradePercentage: 0,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'A',
              gradePercentage: 0,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'B',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'A',
              gradePercentage: 0,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-6bc1-af88-02ae5b23cf47',
          firstName: 'Olivia',
          lastName: 'Murphy',
          score: 42.86,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'B',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'A',
              gradePercentage: 0,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'A',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'A',
              gradePercentage: 0,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'C',
              gradePercentage: 0,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'B',
              gradePercentage: 0,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'B',
              gradePercentage: 0,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'B',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'A',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'B',
              gradePercentage: 0,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'D',
              gradePercentage: 0,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'C',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'D',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'D',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'A',
              gradePercentage: 0,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'B',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0418-6c8b-af88-02ae5b23cf47',
          firstName: 'Carlos',
          lastName: 'Sánchez',
          score: 53.57,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'C',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'B',
              gradePercentage: 0,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'C',
              gradePercentage: 0,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'D',
              gradePercentage: 0,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'C',
              gradePercentage: 0,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'B',
              gradePercentage: 0,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'B',
              gradePercentage: 0,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'B',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'B',
              gradePercentage: 0,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'D',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'C',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6290-af88-02ae5b23cf47',
          firstName: 'William',
          lastName: 'Jones',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6352-af88-02ae5b23cf47',
          firstName: 'Fatima',
          lastName: 'Al-Farsi',
          score: 71.43,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'C',
              gradePercentage: 0,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'B',
              gradePercentage: 0,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'D',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'C',
              gradePercentage: 0,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'B',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'B',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'A',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '5de9fe1f-15e7-408e-9d54-e20eb1d6d359',
          firstName: 'Lucas',
          lastName: 'González',
          score: 82.14,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'A',
              gradePercentage: 0,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'B',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'B',
              gradePercentage: 0,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6416-af88-02ae5b23cf47',
          firstName: 'Anna',
          lastName: 'Wilson',
          score: 78.57,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'C',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'D',
              gradePercentage: 0,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'A',
              gradePercentage: 0,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'D',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'B',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-659d-af88-02ae5b23cf47',
          firstName: 'Thomas',
          lastName: 'Brown',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-672f-af88-02ae5b23cf47',
          firstName: 'Alejandro',
          lastName: 'Ramírez',
          score: 85.71,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'B',
              gradePercentage: 0,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'A',
              gradePercentage: 0,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'B',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: 'bd53fceb-bf03-42b4-ba0d-f0c829d0cd35',
          firstName: 'Mia',
          lastName: 'Taylor',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-67f2-af88-02ae5b23cf47',
          firstName: 'Daniel',
          lastName: 'Clark',
          score: 78.57,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'C',
              gradePercentage: 0,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'B',
              gradePercentage: 0,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'B',
              gradePercentage: 0,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'D',
              gradePercentage: 0,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'C',
              gradePercentage: 0,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'C',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-68b6-af88-02ae5b23cf47',
          firstName: 'Elena',
          lastName: 'Fernández',
          score: 67.86,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'C',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'A',
              gradePercentage: 0,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'B',
              gradePercentage: 0,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'B',
              gradePercentage: 0,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'D',
              gradePercentage: 0,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'A',
              gradePercentage: 0,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'B',
              gradePercentage: 0,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'A',
              gradePercentage: 0,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6976-af88-02ae5b23cf47',
          firstName: 'James',
          lastName: 'Miller',
          score: 100,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'B',
              gradePercentage: 1,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6a35-af88-02ae5b23cf47',
          firstName: 'María',
          lastName: 'Hernández',
          score: 75,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'C',
              gradePercentage: 0,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'C',
              gradePercentage: 0,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'A',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'C',
              gradePercentage: 0,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'C',
              gradePercentage: 0,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'B',
              gradePercentage: 1,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'B',
              gradePercentage: 0,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6af4-af88-02ae5b23cf47',
          firstName: 'Omar',
          lastName: 'Malik',
          score: 96.43,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'B',
              gradePercentage: 0,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'B',
              gradePercentage: 1,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6bbf-af88-02ae5b23cf47',
          firstName: 'Emily',
          lastName: 'Davis',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6c81-af88-02ae5b23cf47',
          firstName: 'Miguel',
          lastName: 'López',
          score: 42.86,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'C',
              gradePercentage: 0,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'A',
              gradePercentage: 0,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'B',
              gradePercentage: 0,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'D',
              gradePercentage: 0,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'B',
              gradePercentage: 0,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'D',
              gradePercentage: 0,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'B',
              gradePercentage: 0,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'D',
              gradePercentage: 0,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'D',
              gradePercentage: 0,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'B',
              gradePercentage: 0,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'D',
              gradePercentage: 0,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'C',
              gradePercentage: 0,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'C',
              gradePercentage: 0,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'A',
              gradePercentage: 0,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'A',
              gradePercentage: 0,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6d42-af88-02ae5b23cf47',
          firstName: 'Sarah',
          lastName: 'Johnson',
          score: null,
          status: 'not_started',
          inClassroom: true,
          statements: [
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 0,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 1,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 2,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 3,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 4,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 5,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 6,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 7,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 8,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 9,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 10,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 11,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 12,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 13,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 14,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 15,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 16,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 17,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 18,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 19,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 20,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 21,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 22,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 23,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 24,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 25,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 26,
            },
            {
              id: null,
              answer: '',
              gradePercentage: null,
              position: 27,
            },
          ],
        },
        {
          id: '1ebe5438-0510-6e05-af88-02ae5b23cf47',
          firstName: 'Isabella',
          lastName: 'Martin',
          score: 96.43,
          status: 'completed',
          inClassroom: true,
          statements: [
            {
              id: '61b9126f-a6a0-4039-849a-abaf394d548f',
              answer: 'D',
              gradePercentage: 1,
              position: 0,
            },
            {
              id: '89c94ae7-04e8-4e53-962f-a5a3ca3cd169',
              answer: 'B',
              gradePercentage: 1,
              position: 1,
            },
            {
              id: '66a24f19-5ade-46aa-a3b0-125f1a571cc8',
              answer: 'D',
              gradePercentage: 1,
              position: 2,
            },
            {
              id: '56325c39-bfc0-4567-93d8-3ee00ebf351f',
              answer: 'D',
              gradePercentage: 1,
              position: 3,
            },
            {
              id: '20d7c531-8928-4f4e-8e76-537ded3822ea',
              answer: 'B',
              gradePercentage: 1,
              position: 4,
            },
            {
              id: '650b6ec7-d4a1-4890-a908-509238f58138',
              answer: 'C',
              gradePercentage: 1,
              position: 5,
            },
            {
              id: '2d939d5d-b1bc-4eda-adae-4c3b30a4278f',
              answer: 'B',
              gradePercentage: 1,
              position: 6,
            },
            {
              id: '6f669efa-17da-4c61-a44a-29db191e0720',
              answer: 'A',
              gradePercentage: 1,
              position: 7,
            },
            {
              id: '232f244d-2dca-4bb0-a064-ba786ef04f95',
              answer: 'B',
              gradePercentage: 1,
              position: 8,
            },
            {
              id: '29ebd970-4f08-4dee-9031-e543eed465a4',
              answer: 'A',
              gradePercentage: 1,
              position: 9,
            },
            {
              id: '07fb8df1-97b0-4f21-a285-b838fdd9e2b5',
              answer: 'D',
              gradePercentage: 1,
              position: 10,
            },
            {
              id: '0e2b4d67-dffa-4df2-9e82-4bfcfd2f68eb',
              answer: 'C',
              gradePercentage: 1,
              position: 11,
            },
            {
              id: 'f451a97e-cb81-4d01-a376-d39404d5bd0f',
              answer: 'D',
              gradePercentage: 1,
              position: 12,
            },
            {
              id: '32b8d1f2-4e09-4aec-ab14-54e03e6612ed',
              answer: 'A',
              gradePercentage: 1,
              position: 13,
            },
            {
              id: 'b8b45449-3ee6-4e6e-b3a3-767329f4ac9a',
              answer: 'A',
              gradePercentage: 1,
              position: 14,
            },
            {
              id: 'dfb646fb-cc64-4056-ab90-d8ff34a7bd14',
              answer: 'A',
              gradePercentage: 1,
              position: 15,
            },
            {
              id: '4920b66c-bfb5-4f8e-9a5c-0e39fb236116',
              answer: 'B',
              gradePercentage: 1,
              position: 16,
            },
            {
              id: '1b331e70-90cd-42be-b821-18bdc5c6236f',
              answer: 'A',
              gradePercentage: 1,
              position: 17,
            },
            {
              id: '7e351508-9c80-413b-b67c-3907845d63b9',
              answer: 'C',
              gradePercentage: 1,
              position: 18,
            },
            {
              id: '5adb2e75-17f0-4419-9ad4-e71240df1063',
              answer: 'D',
              gradePercentage: 1,
              position: 19,
            },
            {
              id: '3f732dfd-5494-4a0e-a47c-b638116071d7',
              answer: 'C',
              gradePercentage: 1,
              position: 20,
            },
            {
              id: '9ac233cd-69e7-44e8-b913-eb269f6bc165',
              answer: 'D',
              gradePercentage: 0,
              position: 21,
            },
            {
              id: '14167c11-5ad8-46d0-9b81-12f85ae482fe',
              answer: 'C',
              gradePercentage: 1,
              position: 22,
            },
            {
              id: 'a05d2c52-a72c-48e4-affb-782ce14cd43a',
              answer: 'B',
              gradePercentage: 1,
              position: 23,
            },
            {
              id: '7671efd1-a968-4aae-9588-f3acd16d0486',
              answer: 'B',
              gradePercentage: 1,
              position: 24,
            },
            {
              id: '82d52318-d107-4327-b77b-8add65dd0009',
              answer: 'C',
              gradePercentage: 1,
              position: 25,
            },
            {
              id: '8ec8fe7d-d5b3-4524-b784-b723b328c76b',
              answer: 'D',
              gradePercentage: 1,
              position: 26,
            },
            {
              id: 'a6862b6c-1e92-45bb-b9d7-0d8eca82087b',
              answer: 'C',
              gradePercentage: 1,
              position: 27,
            },
          ],
        },
      ],
    },
  };
};
